import styled from 'styled-components';

export const TitleStyled = styled.div`
  border-bottom: 1px solid var(--ds-border, var(--ds-fb-border));
  width: 100%;
  display: inline-block;
`;

export const SubtitleStyled = styled.div`
  color: var(--ds-text-subtle, var(--ds-fb-text-subtle));
  padding-bottom: 2em;
  padding-top: 1em;
`;

export const FilterStyled = styled.div`
  margin-top: 1em;
  width: 25%;
`;

export const IconStyled = styled.div`
  padding-right: 6px;
  line-height: 100%;
`;

export const ClickableIconStyled = styled.div`
  padding-right: 6px;
  line-height: 100%;
  &:hover {
    cursor: pointer;
  }
`;
